import schoolAxiosInstance from "@quest/school-axios";
import { BaseGetRequestResponse } from "@quest/types";
import { EducationLevel, ISchool } from "@quest/types/tenant.types";

export interface IIsland {
  id: number;
  name: string;
  is_parent_island: boolean;
  is_active?: boolean;
}
class SchoolDetailService {
  private api = schoolAxiosInstance;

  async getSchoolDetails() {
    const response = await this.api.get<ISchool>("/school");
    return response.data.data;
  }

  async getSchoolEducationLevels() {
    const response = await this.api.get<EducationLevel>(
      "/school/education-levels?selected=true"
    );
    return response.data;
  }

  async getIslandList() {
    const response = await this.api.get<BaseGetRequestResponse<IIsland>>(
      "/assignment/islands?limit=20",
      {
        params: {
          filters: JSON.stringify({
            is_active: true,
          }),
          sortBy: "id",
          sortOrder: "ASC",
        },
      }
    );
    return response.data.data;
  }
}

export const schoolDetailService = new SchoolDetailService();
